import axiosInstance from "../axiosInstance"
import type {
  MotoBrandResponseDto,
  CreateMotoBrandDto,
  UpdateMotoBrandDto,
  MotoBrandListParams,
  MotoBrandListResponseDto,
  DeleteMotoBrandResponseDto,
} from "../types/motoBrand.types"

/**
 * Moto Brand API Client
 * Direct API calls using axios instance
 */
export const motoBrandClient = {
  // Get moto brand by ID
  getMotoBrandById: (id: string): Promise<MotoBrandResponseDto> => {
    return axiosInstance.get(`/moto-brands/${id}`)
  },

  // List moto brands with filters
  getMotoBrands: (params?: MotoBrandListParams): Promise<MotoBrandListResponseDto> => {
    // API expects 'page' and 'limit' (not 'page_number'/'limit_number')
    // Filter out undefined values to avoid sending them to the API
    const apiParams: Record<string, string | number> = {}
    
    if (params) {
      if (params.page !== undefined) {
        apiParams.page = params.page
      }
      if (params.limit !== undefined) {
        apiParams.limit = params.limit
      }
      if (params.search !== undefined && params.search !== "") {
        apiParams.search = params.search
      }
    }
    
    return axiosInstance.get("/moto-brands", { params: apiParams })
  },

  // Create moto brand (Admin only)
  createMotoBrand: (data: CreateMotoBrandDto): Promise<MotoBrandResponseDto> => {
    return axiosInstance.post("/moto-brands", data)
  },

  // Update moto brand (Admin only)
  updateMotoBrand: (id: string, data: UpdateMotoBrandDto): Promise<MotoBrandResponseDto> => {
    return axiosInstance.put(`/moto-brands/${id}`, data)
  },

  // Delete moto brand (Admin only)
  deleteMotoBrand: (id: string): Promise<DeleteMotoBrandResponseDto> => {
    return axiosInstance.delete(`/moto-brands/${id}`)
  },
}

